import { Group } from "../ars_ldm";
import { isNamedObject } from "./isNamedObject";
import { isWhereClause } from "./isWhereClause";

/**
 * Type guard to check if a value is a Group.
 *
 * Validates that the object has the required properties of a Group:
 * - Extends NamedObject (name, description?, label?)
 * - Extends WhereClause (level, order, condition?, compoundExpression?)
 * - Has an id string
 *
 * @param obj - The value to check
 * @returns True if the value is a Group, false otherwise
 */
export const isGroup = (obj: unknown): obj is Group => {
  // Check NamedObject and WhereClause
  if (!isNamedObject(obj) || !isWhereClause(obj)) return false;
  // Check id
  const chkObj = obj as Group;
  if (typeof chkObj.id !== "string") return false;
  // Everything is good
  return true;
};
